export const extractCosIndexObjectsFromReferenceRecords = records => records.reduce((acc, {
  id,
  referencedObject
}) => Object.assign({}, acc, {
  [id]: referencedObject
}), {});